export default __webpack_public_path__ + "static/blast_logo-3ba10d915f546c88eb847e979a329a71.png";